module.exports = __webpack_public_path__ + "img/person_outline_black_24dp.04b43030.svg";